<template><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 93 93">
  <path d="M21.83 10.56a7.83 7.83 0 100 15.65 7.83 7.83 0 000-15.65zM15.08 32.15h13.5V75.6h-13.5zM62.95 31.07c-6.57 0-10.97 3.6-12.78 7.01H50v-5.93H37.04v43.44h13.5v-21.5c0-5.66 1.07-11.15 8.1-11.15 6.92 0 7.01 6.48 7.01 11.52v21.12h13.5V51.76c0-11.7-2.53-20.7-16.2-20.7z" />
</svg>
</template>